import * as React from 'react';
import{} from 'semantic-ui-react';

const Rodape = () => {
    return (
        <div className='rodape'>(41) 3021-5252 - Avenida Iguaçu, 1815, Água verde, Curitiba/PR, CEP: 80240-030</div>
    );
}

export default Rodape;